import { h, Component } from 'preact';

import style from '../../style/header.sass';

import HandlebarsHandler from '../util/handlebarsHandler.js';

export default class HeaderTitle extends Component {
  render(props, state) {
    if(!props.mergedLandingPageData){
      return null;
    }
    const handlebarsHandler = new HandlebarsHandler();
    const titleHtml = handlebarsHandler.renderToHtml(
      'headerTitleTemplate',
      props.mergedLandingPageData.headerTitleTemplate,
      props.mergedLandingPageData
    );
    return (
      <div className={style.tagline} dangerouslySetInnerHTML={{__html: titleHtml}}></div>
    );
  }
}